import Box from '@/components/UI/box/Box'
import TextField from '@/components/UI/textField/TextField'
import { ChangeEvent, FormEvent, useEffect, useRef, useState } from 'react'
import styles from './PhoneNumberForm.module.scss'
import Button from '@/components/UI/button/Button'
import useLogin from '../../../hooks/useLogin'
import { loginOtp } from '@/redux/store/actions/auth'
import { useDispatch } from 'react-redux'
import { persianToEnglishNumbers } from '@/helpers/persianToEnglishNumbers'

const PhoneNumberForm = () => {
  const { handleChangeStep, handleSetPhoneNumber, phoneNumberDefault } =
    useLogin()
  const dispatch = useDispatch()
  const [phone, setPhone] = useState(phoneNumberDefault)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (inputRef.current) {
      // handle Iphone keyboard popup
      requestAnimationFrame(() => {
        inputRef.current?.focus()
      })
    }
  }, [])

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    let phoneNumber = phone
    if (phoneNumber.startsWith('98')) {
      phoneNumber = '0' + phoneNumber.slice(2)
    } else if (/^[1-9]/.test(phoneNumber)) {
      phoneNumber = '0' + phoneNumber
    }
    setLoading(true)
    setError('')

    dispatch(
      loginOtp(phoneNumber, ({ message, status }) => {
        setLoading(false)
        if (status === 'SUCCESS') {
          setError('')
          handleSetPhoneNumber(phoneNumber)
          handleChangeStep('GETVERIFICATIONCODE')
        } else {
          setError(message)
        }
      }),
    )
  }

  const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
    // const value = digitsFaToEn(e.target.value.replace(/\s/g, ''))
    const value = persianToEnglishNumbers(e.target.value)
    if (
      (/^(\+?98|0|9)[\u06F0-\u06F90-9]*$/.test(value) &&
        ((value.startsWith('98') && value.length <= 12) ||
          (value.startsWith('0') && value.length <= 11) ||
          (/^[1-9]/.test(value) && value.length <= 10))) ||
      !value
    ) {
      setPhone(value)
    }
  }

  const handleClear = () => {
    setPhone('')
  }

  return (
    <form className={styles['form']} onSubmit={handleSubmit}>
      <TextField
        ref={inputRef}
        type={'tel'}
        inputMode={'numeric'}
        label="شماره همراه"
        sizes={'medium'}
        value={phone}
        onChange={handleInput}
        error={!!error}
        description={error}
        onClear={handleClear}
        className={styles['input-phone']}
      />
      <Box>
        <Button
          type="submit"
          format="primary"
          size={'large'}
          loading={loading}
          disabled={
            loading ||
            (phone.startsWith('98') && phone.length < 12) ||
            (phone.startsWith('0') && phone.length < 11) ||
            (/^[1-9]/.test(phone) && phone.length < 10) ||
            !phone.length
          }
        >
          ثبت و ادامه
        </Button>
      </Box>
    </form>
  )
}

export default PhoneNumberForm
